import React, { useState } from "react";
import api from "../../../configs/api";
import { showError, showSuccess } from "../../../utils/toastUtils";
import { Send, X } from "lucide-react";

const ProductInquiryModal = ({
  classname = "",
  inputClassName = "",
  productId,
  cartItems = [],
  onClose,
  onSuccess,
}) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // Determine which products to send
  const productsToSend = cartItems.length
    ? cartItems
    : productId
      ? [{ productId, quantity: 1 }]
      : [];

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validate = () => {
    const { name, email, phone, message } = form;

    if (!name.trim()) {
      showError("Please enter your name");
      return false;
    }
    if (!email.trim()) {
      showError("Please enter your email");
      return false;
    }
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      showError("Invalid email address");
      return false;
    }
    if (!phone.trim()) {
      showError("Please enter your phone number");
      return false;
    }
    if (phone.length < 10) {
      showError("Invalid phone number");
      return false;
    }
    if (!message.trim()) {
      showError("Please enter a message");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Prepare payload for backend
    const payload = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      message: form.message,
      products: productsToSend.map((p) => ({
        product: p.productId,
        quantity: p.quantity,
      })),
    };

    try {
      setLoading(true);
      const res = await api.post("/product-inquiries", payload);

      console.log("product checkout", res);
      if (res?.data?.success) {
        showSuccess("Inquiry sent successfully!");
        setForm({ name: "", email: "", phone: "", message: "" });
        if (onSuccess) onSuccess();
        if (onClose) onClose();
      }
    } catch (err) {
      console.error(err);
      showError(
        err?.response?.data?.message ||
          "Failed to send inquiry. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div
        className={`${classname} relative w-full max-w-md bg-gradient-to-br from-[#041122] via-[#2a0535] to-[#B3129E] p-8 md:p-10 text-white shadow-lg rounded-lg`}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-white/70 hover:text-white"
        >
          <X size={24} />
        </button>

        <h2 className="text-xl font-semibold mb-4">Send Detail for Proceed</h2>

        {/* Show product summary if multiple */}
        {cartItems.length > 0 && (
          <div className="mb-4 text-sm bg-white/10 p-3 rounded">
            <p className="font-medium">Products:</p>
            <ul className="list-disc list-inside text-white/80">
              {cartItems.map((item) => (
                <li key={item.productId}>
                  Product : {item.productName} × Qt: {item.quantity}
                </li>
              ))}
            </ul>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Full Name"
            className={`${inputClassName} w-full px-4 py-3 text-sm bg-white/10 border border-white/20 placeholder-white/60 focus:outline-none focus:border-white`}
          />

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email Address"
            className={`${inputClassName} w-full px-4 py-3 text-sm bg-white/10 border border-white/20 placeholder-white/60 focus:outline-none focus:border-white`}
          />

          <input
            type="tel"
            name="phone"
            maxLength={10}
            value={form.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            className={`${inputClassName} w-full px-4 py-3 text-sm bg-white/10 border border-white/20 placeholder-white/60 focus:outline-none focus:border-white`}
          />

          <textarea
            rows="4"
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Your Message"
            className={`${inputClassName} w-full px-4 py-3 text-sm bg-white/10 border border-white/20 placeholder-white/60 focus:outline-none focus:border-white`}
          />

          <button
            type="submit"
            disabled={loading}
            className={`${inputClassName} flex items-center justify-center gap-2 bg-white text-[#B3129E] px-6 py-3 w-full text-sm font-semibold transition hover:bg-gray-100 disabled:opacity-60`}
          >
            {loading ? "Sending..." : "Send"}
            <Send size={16} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProductInquiryModal;
